import styled, { css } from 'styled-components';

export const IconWrapper = styled.div`
  line-height: 0;
  color: var(--blue-400);
`;

export const LabelWrapper = styled.div`
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const filledStyles = css`
  padding: 8px;
  border-radius: 4px;

  &.active {
    background: var(--blue-50);
  }

  &:disabled {
    &:hover,
    &:focus {
      background: none;
    }
  }
`;

const lineStyles = css`
  padding: 8px 12px;
  border-bottom: 1px solid var(--coolGray-200);
  border-radius: 0;

  &.active {
    padding-bottom: 7px;
    border-bottom-width: 2px;
    border-bottom-color: var(--blue-900);
  }

  &:enabled,
  a& {
    &:hover,
    &:focus {
      border-bottom-color: var(--blue-400);
    }
  }
`;

const shouldForwardProp = (prop) => !['activeClassName'].includes(prop);

export const Wrapper = styled('button').withConfig({ shouldForwardProp })`
  min-height: 40px;
  max-width: 250px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: 0;
  border-radius: 4px;
  color: inherit;
  font: inherit;
  cursor: pointer;
  outline: none;
  transition: all 250ms ease, font-weight 0ms;

  &.active {
    color: var(--blue-900);
    font-weight: 600;
  }

  &:disabled {
    cursor: not-allowed;

    ${LabelWrapper} {
      color: var(--coolGray-400);
    }

    ${IconWrapper} {
      color: var(--coolGray-300);
    }

    &:hover, &:focus {
      ${LabelWrapper} {
        color: var(--coolGray-400);
      }

      ${IconWrapper} {
        color: var(--coolGray-300);
      }
    }
  }

  &:enabled,
  a& {
    &:hover,
    &:focus {
      background-color: var(--indigo-50);
      text-decoration: none;
    }

    &:focus-visible {
      box-shadow: 0 0 0 2px var(--outlineColor);
    }
  }

  ${(props) =>
    (() => {
      switch (props.variant) {
        case 'filled':
          return filledStyles;
        case 'line':
        default:
          return lineStyles;
      }
    })()}}
`;

export const Badge = styled.div``;
